export default class Fonts {
    public static get DefaultFont(): string {
        return "nunito-black";
    }

    public static get Arial(): string {
        return "arial";
    }

    public static get LunchBoxRegular(): string {
        return "lunchbox-regular";
    }
}
